import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSelectiontoolIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "3 0 30.945 32.003",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.994,0l9.793,24.157-.927.929L9.906,21.157l-8.987,4L0,24.239Z",
		transform: "matrix(0.799, -0.602, 0.602, 0.799, 0, 11.908)"
	})
});
export default SvgSelectiontoolIcon;
